exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sk-chasing-dots {\n    top: 50%;\n    margin: auto;\n    width: 40px;\n    height: 40px;\n    position: relative;\n    text-align: center;\n    animation: sk-chasingDotsRotate 2s infinite linear;\n}\n\n.sk-chasing-dots .sk-child {\n    width: 60%;\n    height: 60%;\n    display: inline-block;\n    position: absolute;\n    top: 0;\n    border-radius: 100%;\n    animation: sk-chasingDotsBounce 2s infinite ease-in-out;\n}\n\n.sk-chasing-dots .sk-dot2 {\n    top: auto;\n    bottom: 0;\n    animation-delay: -1s;\n}\n\n@keyframes sk-chasingDotsRotate {\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n@keyframes sk-chasingDotsBounce {\n    0%, 100% {\n        transform: scale(0);\n    }\n    50% {\n        transform: scale(1);\n    }\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Projects/Hb.Bet/ServerAPI/AdminAngular/src/app/spinner/spinkit-css/sk-chasing-dots.css
// module id = ../../../../../src/app/spinner/spinkit-css/sk-chasing-dots.css
// module chunks = main